import linkViewers from './linkViewers'
import multiViewControlTitles from './multiViewControlTitles'
import { AssetsService } from '@coosmo/shared-utils'

const arrowDown = AssetsService.getSvgIcon('arrow-down.svg')
const plus = AssetsService.getSvgIcon('plus.svg')

let state
let allImagesData

function getImagesSelectionList(currentImageIndex, allImagesData) {
  let out = ''
  const fullTitles = getFullTitles(allImagesData)

  allImagesData.forEach((imageData, index) => {
    const imagesIsSelected = currentImageIndex === index
    if (imagesIsSelected) {
      state[index].selectedImageIndex = index
    }
    const selectionClass = imagesIsSelected ? 'selected' : ''
    out += `<div id=imageData${index} data-id="${index}" data-select-id="${currentImageIndex}" class="selectImageListElement ${selectionClass}">${fullTitles[index]}</div>
`
  })

  return out
}

function createSelect(index, title, allImagesData) {
  return `
<div class="selectImage" data-id="${index}">
    <div class="selectImageContentHeader">
      <div class="selectionText" data-id="${index}">${title}</div>
      <div class="arrow">
          <img src="${arrowDown}">
      </div>
    </div>
    <div class="selectImageContentBody"">
        <div id="imagesList">
        ${getImagesSelectionList(index, allImagesData)}
        </div>
        <button id="remove${index}" class="removeButton" data-id="${index}">Remove view</button>
    </div>
</div>`
}

function getFullTitles(imagesData) {
  return multiViewControlTitles.mapTitles(
    imagesData.map(data => data.title),
    imagesData.map(data => data.acquisitionType),
    imagesData.map(data => data.acquisitionDate)
  )
}

function createSelectImagesDom(imagesData) {
  const fullTitles = getFullTitles(imagesData)

  return imagesData
    .map((data, index) => {
      return createSelect(index, fullTitles[index], imagesData)
    })
    .reduce((full, current) => full + current, '')
}

function hideAddImageButton() {
  const addImageButton = document.getElementById('addImageButton')
  addImageButton.classList.remove('visible')
}

function showAddImageButton() {
  const visibleViewersCount = state.filter(s => s.visible).length
  const viewersCount = state.length

  const addImageButton = document.getElementById('addImageButton')
  if (visibleViewersCount < viewersCount) {
    addImageButton.classList.add('visible')
  } else {
    addImageButton.classList.remove('visible')
  }
}

function sendUpdateImagesVisibilityMessage() {
  const updateImagesVisibilityEvent = new CustomEvent('updateImagesVisibility', {
    detail: {
      state: state
    }
  })

  const viewers = Array.from(document.getElementsByClassName('viewer'))
  viewers.forEach(viewer => viewer.dispatchEvent(updateImagesVisibilityEvent))
  const removeButtons = Array.from(document.getElementsByClassName('removeButton'))
  removeButtons.forEach(button => button.dispatchEvent(updateImagesVisibilityEvent))
  const modeButtons = Array.from(document.getElementsByClassName('radio-button-mode'))
  modeButtons.forEach(button => button.dispatchEvent(updateImagesVisibilityEvent))
}

function sendChangeSelectedImageMessage(viewerPosition, viewerRotation) {
  const changeSelectedImageEvent = new CustomEvent('changeSelectedImage', {
    detail: { state: state }
  })

  if (viewerPosition) {
    changeSelectedImageEvent.detail.viewerPosition = viewerPosition
  }

  if (viewerRotation) {
    changeSelectedImageEvent.detail.viewerRotation = viewerRotation
  }

  const selectImageControls = Array.from(document.getElementsByClassName('selectImage '))
  const viewers = Array.from(document.getElementsByClassName('viewer'))
  const controlsTuUpdate = [selectImageControls, viewers]
  controlsTuUpdate.forEach(c => c.forEach(element => element.dispatchEvent(changeSelectedImageEvent)))

  showAddImageButton()
}

function toggleOpen(selectImageControl) {
  selectImageControl.addEventListener('click', () => {
    selectImageControl.classList.toggle('open')
  })
}

function closeSelect(selectImageControl) {
  selectImageControl.classList.remove('open')
}

function setupEventsFor(selectImageControl) {
  toggleOpen(selectImageControl)

  const removeViewerButtons = Array.from(selectImageControl.getElementsByClassName('removeButton'))

  removeViewerButtons.forEach(removeViewerButton => {
    removeViewerButton.addEventListener('click', () => {
      hideAddImageButton()
      linkViewers.disable()

      const id = removeViewerButton.dataset.id
      state[id].visible = false

      sendUpdateImagesVisibilityMessage()
      sendChangeSelectedImageMessage()

      setTimeout(() => {
        linkViewers.enable()
        showAddImageButton()
      }, 400)
    })
  })

  const selectImageList = Array.from(selectImageControl.getElementsByClassName('selectImageListElement '))

  selectImageList.forEach((selectImageElement, index) => {
    const selectedImageId = selectImageElement.dataset.id
    const imageSelectorId = selectImageElement.dataset.selectId

    selectImageElement.addEventListener('click', event => {
      const imageData = allImagesData[selectedImageId]
      event.stopPropagation()

      const selectorImageState = state[imageSelectorId]

      selectorImageState.title = imageData.title
      selectorImageState.uuid = imageData.uuid
      selectorImageState.tileSources = imageData.tileSources
      selectorImageState.selectedImageIndex = index

      sendChangeSelectedImageMessage()
    })

    selectImageControl.addEventListener('changeSelectedImage', event => {
      const currentControlId = selectImageControl.dataset.id
      const currentControlState = event.detail.state[currentControlId]

      if (selectImageElement.dataset.id.toString() === currentControlState.selectedImageIndex.toString()) {
        const selectTitle = Array.from(selectImageControl.getElementsByClassName('selectionText')).filter(
          text => text.dataset.id === imageSelectorId
        )[0]

        selectTitle.innerHTML = getFullTitles(allImagesData)[selectedImageId]

        selectImageElement.classList.add('selected')
      } else {
        selectImageElement.classList.remove('selected')
      }

      if (currentControlState.visible) {
        selectImageControl.classList.remove('hidden')
      } else {
        selectImageControl.classList.add('hidden')
      }
    })
  })
}

function setupEvents() {
  const selectImageElements = Array.from(document.getElementsByClassName('selectImage'))
  selectImageElements.forEach(selectImageElement => {
    setupEventsFor(selectImageElement)
  })

  const controlsContainer = document.getElementById('controlsContainer')
  controlsContainer.addEventListener('focusout', e => {
    selectImageElements.forEach(selectImageElement => {
      controlsContainer.focus()
      if (
        e.relatedTarget &&
        !e.relatedTarget.classList.contains('removeButton') &&
        !e.relatedTarget.classList.contains('selectImageListElement')
      ) {
        closeSelect(selectImageElement)
      }
    })
  })

  const addImageButton = document.getElementById('addImageButton')
  addImageButton.addEventListener('click', e => {
    linkViewers.disable()
    const stateOfViewerToReEnable = state.filter(s => !s.visible)[0]
    stateOfViewerToReEnable.visible = true

    sendUpdateImagesVisibilityMessage()
    Array.from(document.getElementsByClassName('selectImage'))
      .filter(select => select.dataset.id === `${stateOfViewerToReEnable.id}`)[0]
      .classList.remove('hidden')

    showAddImageButton()
    setTimeout(() => {
      linkViewers.enable()
    }, 400)
  })

  const removeButtons = Array.from(document.getElementsByClassName('removeButton'))
  removeButtons.forEach(button => {
    button.addEventListener('updateImagesVisibility', () => {
      const numberOfVisibleImages = state.filter(s => s.visible).length
      if (numberOfVisibleImages > 1) {
        button.classList.remove('disabled')
        button.removeAttribute('disabled')
      } else {
        button.classList.add('disabled')
        button.setAttribute('disabled', 'true')
      }
    })
  })
}

export default {
  createDom: function (imagesData) {
    allImagesData = imagesData
    if (!imagesData[0].multi) {
      return
    }

    state = imagesData.map((imageData, index) => {
      return {
        id: index,
        selectedImageId: -1,
        title: imageData.title,
        uuid: imageData.uuid,
        tileSources: imageData.tileSources,
        rotation: 0,
        visible: true
      }
    })

    const selectImagesDom = createSelectImagesDom(imagesData)
    const addImageButtonDom = `
<div id="addImageButton" class="addImageButton">
    <img src="${plus}">
</div>
    `
      .replace(/\n/g, '')
      .replace(/>\s+/g, '>')

    const controlsDom = `
<div id="controlsContainer" tabindex="0" >
    ${selectImagesDom}
    ${addImageButtonDom}
</div>
`
      .replace(/\n/g, '')
      .replace(/>\s+/g, '>')

    const widgetContainer = document.getElementById('widgetContainer')
    widgetContainer.insertAdjacentHTML('beforeend', controlsDom)

    setupEvents()
  },

  saveState: function () {
    const stateInDOM = document.getElementById('controls-state')
    stateInDOM.setAttribute('data-state', JSON.stringify(state))
    return state.filter(s => s.visible).length
  },

  restoreState: function (viewerPosition, viewerRotation) {
    const stateInDOM = document.getElementById('controls-state')
    state = JSON.parse(stateInDOM.getAttribute('data-state'))
    sendUpdateImagesVisibilityMessage()
    sendChangeSelectedImageMessage(viewerPosition, viewerRotation)
  }
}
